<template>
  <div>
    <section-definition
      :title="page.title"
      :breadcrumbs="breadcrumbs"
    ></section-definition>

    <!-- <v-container fluid grid-list-xl page>
      <v-layout row wrap>
        <v-flex xs12 sm8 md12>
          <section-header v-text="page.headline"></section-header>
          <div class="subheading justify" v-html="page.description"></div>
          <div class="my-5"></div>
        </v-flex>
      </v-layout>

      <v-flex xs12 md8>
        <v-card>
          <v-toolbar color="transparent" flat>
            <v-toolbar-title>Alquileres</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>more_vert</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
          <line-chart
              :data="rentgraphdata"
              :options="rentsinfo.option"
              :height="300"
            ></line-chart>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-container> -->
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-card>
          <v-card-title>
            <download-excel
              :data="rents"
              :fields="json_fields"
              name="alquileres.xls"
              worksheet="Alquileres"
            >
              <v-btn round color="primary" dark bold outline >Descargar Excel</v-btn>
            </download-excel>
            <v-menu
              class="ml-5"
              ref="menu1"
              :close-on-content-click="false"
              v-model="menu1"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="computedDateFormatted"
                label="Fecha inicio"
                hint="DD/MM/YYYY"
                persistent-hint
                prepend-icon="event"
              ></v-text-field>
              <v-date-picker
                v-model="date"
                no-title
                locale="es-es"
                :first-day-of-week="1"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
            <v-menu
              class="ml-5"
              :close-on-content-click="false"
              v-model="menu2"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
              readonly
            >
              <v-text-field
                slot="activator"
                v-model="computedDateFormatted2"
                label="Fecha final"
                hint="DD/MM/YYYY"
                persistent-hint
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="date2"
                  locale="es-es"
                :first-day-of-week="1"
                no-title
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
            <v-btn class="ml-5" round color="primary" dark bold outline @click="refresh()">Filtrar por fechas</v-btn>
            <v-text-field
              class="ml-5"
              v-model="search"
              append-icon="search"
              label="Buscar..."
              single-line
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="rents"
            :search="search"
            :loading="isLoading"
            :pagination.sync="pagination"
            class="elevation-1"
            rows-per-page-text="Filas por página"
            :rows-per-page-items="[15, 30, 50, { text: 'todas', value: -1 }]"
          >
            <v-progress-linear
              slot="progress"
              color="blue"
              indeterminate
            ></v-progress-linear>

            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.item.idrent }}</td>
              <td class="text-xs-center">{{ props.item.owneralias }}</td>
              <td class="text-xs-center">{{ formatDate(props.item.rentfrom) }}</td>
              <td class="text-xs-center">{{ formatDate(props.item.rentto) }}</td>
              <td class="text-xs-center">{{ props.item.renttotaldays }}</td>
              <td class="text-xs-center">{{ props.item.rentprice }}</td>
              <td class="text-xs-center">{{ props.item.rentfinalprice }}</td>
              <td class="text-xs-center">{{ props.item.rentfinalprice }}</td>
              <td class="text-xs-center">{{ props.item.rentpriceexcess }}</td>
              <td class="text-xs-center">{{ props.item.machineserialnumber }}</td>
              <td class="text-xs-center">
                <v-chip :color="props.item.rentstatuscolor" dark>{{ props.item.rentstatuslabel }}</v-chip>
              </td>
              <td class="text-xs-center">{{ formatDate(props.item.rentcreationdate) }}</td>
              <td class="text-xs-center">{{ props.item.useralias }}</td>
              <td class="text-xs-center">{{ props.item.machinename }}</td>
              <td :class="props.item.stateclass">{{ props.item.rentphaselabel }}</td>
              <td class="text-xs-center">{{ props.item.rentplace }}</td>
              <td class="text-xs-center">{{ props.item.transportNeededlabel }}</td>
              
              <td class="justify-center layout px-0">
                <v-icon
                  small
                  class="mr-2"
                  @click="viewChat(props.item)"
                  title="Ver chat"
                >
                  chat
                </v-icon>

                <v-icon
                  small
                  class="mr-2"
                  @click="cancelRent(props.item)"
                  title="Eliminar alquiler"
                >
                  delete
                </v-icon>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >
              La búsqueda de "{{ search }}" no ha encontrado resultados.
            </v-alert>
          </v-data-table>
        </v-card>
      </v-layout>

      <v-dialog v-model="isShowChatDialog" max-width="500px">
        <v-card>
          <v-toolbar color="pink" dark>
            <v-toolbar-side-icon></v-toolbar-side-icon>

            <v-toolbar-title
              >Chat de alquiler {{ currentrentid }}</v-toolbar-title
            >

            <v-spacer></v-spacer>
          </v-toolbar>

          <v-list two-line>
            <template v-for="(item, key) in currentChat">
              <v-list-tile
                :key="item.senderName"
                avatar
                ripple
                @click="toggle(index)"
              >
                <v-list-tile-content>
                  <v-list-tile-title
                    >{{ item.senderName }} -
                    {{ item.formattedTime }}</v-list-tile-title
                  >
                  <v-list-tile-sub-title class="text--primary">{{
                    item.headline
                  }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title>{{
                    item.messageText
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
            </template>
          </v-list>
        </v-card>

        <v-card>
          <!--
          <v-card-title>
            <span class="headline">Chat de alquiler {{currentRent}}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                    <ul>
                <li v-for="(value, key2) in currentChat">{{ value.senderName }}: {{ value.messageText }} </li>
                </ul>

              </v-layout>
            </v-container>
          </v-card-text>
        -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" @click.native="isShowChatDialog = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="isCancelRentDialog" persistent max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Eliminar alquiler</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap> </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              @click.native="isCancelRentDialog = false"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" @click.native="confirmCancelrent"
              >Eliminar alquiler</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackresult"
        :color="snackcolor"
        :timeout="6000"
        top="true"
      >
        {{ snacktext }}
        <v-btn dark flat @click="snackresult = false">
          Cerrar
        </v-btn>
      </v-snackbar>
    </v-container>

    <!--   
  <v-flex xs12 sm6 md6 lg4 v-for="(item, idx) in chats" :key="idx">
    <ul>
  <li v-for="(value, key2) in item">{{ value.senderName }}: {{ value.messageText }} </li>
</ul>
    {{idx}}
  </v-flex>
-->
  </div>
</template>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import PlainTableOrder from "@/components/Widgets/list/PlainTableOrder";
import { db } from "../../firebase";
import { debug } from "util";
import {
  lineChartJs as lineChartData,
  barChartJs as barChartData
} from "@/data/ChartWidget";
import LineChart from "@/components/ChartJs/LineChart";

export default {
  mixins: [validationMixin],

  data() {
    return {
      search: "",
      pagination: {
        sortBy: 'idrent',
        descending: true
      },
      headers: [
        { text: "ID alquiler", value: "idrent"},
        { text: "Concesión", value: "owneralias" },
        { text: "Desde", value: "rentfrom" },
        { text: "Hasta", value: "rentto" },
        { text: "Duración", value: "renttotaldays" },
        { text: "Precio Final(€)", value: "rentprice" },
        { text: "Precio Negociado(€)", value: "rentfinalprice" },
        { text: "Precio Liquidación(€)", value: "rentfinalprice" },
        { text: "Fianza (€)", value: "rentpriceexcess" },
        { text: "Nº Serie", value: "machineserialnumber" },
        { text: "Estado", value: "rentstatuslabel" },
        { text: "Fecha alta", value: "rentcreationdate" },
        { text: "Propietario", value: "useralias" },
        { text: "Equipo ", value: "machinename" },
        { text: "Fase", value: "rentphaselabel" },
        { text: "Lugar de entrega", value: "rentplace" },
        { text: "Transporte", value: "transportNeededlabel" },
        // { text: "Fecha inicio ", value: "rentfromcalc" },
        // { text: "Fecha fin ", value: "renttocalc" },
        { text: "Acciones", value: "" }
      ],
      rents: [],
      currentrentid: null,
      currentchat: null,
      chats: [],
      chatmessages: [],
      isLoading: false,
      isShowChatDialog: false,
      isCancelRentDialog: false,
      snackbar: false,
      snackresult: false,
      snacktext: "",
      snackcolor: "success",
      page: {
        title: "Alquileres",
        headline: "Lista de alquileres",
        description: "Alquileres no cancelados"
      },
      breadcrumbs: [
        {
          text: "Listado de alquileres",
          disabled: false
        }
      ],
      date: null,
      date2: null,
      dateFormatted: null,
      dateFormatted2: null,
      menu1: false,
      menu2: false,
      bymonth: {},
      rentmonth: [],
      rentsinfo: {
        data: {
          labels: [
            "Enero",
            "Febreo",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre"
          ],
          datasets: [
            {
              label: "Alquileres",
              fill: false,
              data: [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              borderColor: this.$vuetify.theme.primary,
              pointBorderColor: this.$vuetify.theme.primary,
              pointBackgroundColor: this.$vuetify.theme.primary,
              shadowOffsetX: 3,
              shadowOffsetY: 3,
              shadowBlur: 10,
              shadowColor: "rgba(98, 0, 234, 0.5)",
              pointRadius: 4,
              pointBevelWidth: 3,
              pointBevelHighlightColor: "rgba(255, 255, 255, 0.75)",
              pointBevelShadowColor: "rgba(98, 0, 234, 0.5)",
              pointHoverRadius: 6,
              pointHoverBevelWidth: 4.5,
              pointHoverInnerGlowWidth: 20,
              pointHoverInnerGlowColor: `rgba(98, 0, 234, 0.5)`,
              pointHoverOuterGlowWidth: 20,
              pointHoverOuterGlowColor: this.$vuetify.theme.secondary,
              tension: 0.15
            }
          ]
        },
        option: {
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            mode: "index",
            intersect: false
          },
          hover: {
            mode: "nearest",
            intersect: true
          },
          legend: {
            display: false
          },
          spanGaps: true,
          scales: {
            xAxes: [
              {
                display: true,
                scaleLabel: {
                  display: false,
                  labelString: "Month"
                }
              }
            ],
            yAxes: [
              {
                display: true,
                scaleLabel: {
                  display: false,
                  labelString: "Value"
                }
              }
            ]
          }
        },
        gradient: true,
        gradientSet: ["#80b6f4", "#f49080"]
      },
      json_fields: {
        "ID alquiler": "idrent",
        "Concesión": "owneralias",
        'Desde': {
          field: 'rentfrom',
          callback: value => {
            return this.formatDate(value);
          }
        },
        'Hasta' : {
          field: 'rentto',
          callback: value => {
            return this.formatDate(value);
          }
        },
        "Duracíon (días)": "renttotaldays",
        "Precio final (€)": {
          field: "rentprice",
          callback: value => {
            var valstr = value.toString();
            if (valstr.indexOf(".") > 0) {
              var newvalue = valstr.replace(".", ",");
              return newvalue;
            }
            return value;
          }
        },
        "Precio negociado (€)": {
          field: "rentfinalprice",
          callback: value => {
            var valstr = value.toString();
            if (valstr.indexOf(".") > 0) {
              var newvalue = valstr.replace(".", ",");
              return newvalue;
            }
            return value;
          }
        },
        "Precio liquidación (€)": {
          field: "rentfinalprice",
          callback: value => {
            var valstr = value.toString();
            if (valstr.indexOf(".") > 0) {
              var newvalue = valstr.replace(".", ",");
              return newvalue;
            }
            return value;
          }
        },
        "Fianza (€)": {
          field: "rentpriceexcess",
          callback: value => {
            var valstr = value.toString();
            if (valstr.indexOf(".") > 0) {
              var newvalue = valstr.replace(".", ",");
              return newvalue;
            }
            return value;
          }
        },
        "Número de serie": "machineserialnumber",
        "Nombre del estado": "rentstatuslabel",
        "Fecha de alta": {
          field: 'rentcreationdate',
          callback: value => {
            return this.formatDate(value);
          }
        }
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ]
    };
  },
  firebase: {
    chats: db.ref("/chat_rents/")
  },
  components: {
    PlainTableOrder,
    LineChart
  },
  computed: {
    rentgraphdata() {
      return this.rentsinfo.data;
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    computedDateFormatted2() {
      return this.formatDate(this.date2);
    }
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },

    date2() {
      this.dateFormatted2 = this.formatDate(this.date2);
    }
  },
  mounted: function() {
    this.loadRents();
  },
  methods: {
    loadData() {
      const self = this;
      self.isLoading = true;
      let url = process.env.VUE_APP_BASE_URI + "/getrentsforcompany";
      self.$http.get(url).then(
        function(success) {
          var transporterstemp = success.data.transporters;
          var id1 = transporterstemp[0].iduser;
          self.isLoading = false;
        },
        function(error) {
          self.isLoading = false;
          self.$toast.open({
            duration: 5000,
            message: self.$t("myMachinesErrorGetMachines"),
            type: "is-danger"
          });
        }
      );
    },

    getColor(status) {
      if (status > 7) return "red";
      else if (status > 2) return "orange";
      else return "green";
    },

    viewChat(item) {
      const self = this;
      this.currentrentid = item.idrent;
      db.ref("/chat_rents/" + item.rentuuid)
        .once("value")
        .then(function(snapshot) {
          self.currentChat = snapshot.val();
        });
      this.isShowChatDialog = true;
    },

    cancelRent(item) {
      this.currentrentid = item.rentuuid;
      this.isCancelRentDialog = true;
    },
    confirmCancelrent() {
      const self = this;
      let url = process.env.VUE_APP_BASE_URI + "/cancelrent/" + this.currentrentid;
      self.$http.get(url, self.userData).then(
        function(success) {
          self.isCancelRentDialog = false;
          self.snacktext = "El alquiler ha sido eliminado";
          self.snackcolor = "success";
          self.snackresult = true;
        },
        function(error) {
          self.isCancelRentDialog = false;

          self.snacktext = "Error. No se ha podido elminar el alquiler";
          self.snackcolor = "red";
          self.snackresult = true;
        }
      );
    },

    loadRents() {
      const self = this;
      self.isLoading = true;
      let url = process.env.VUE_APP_BASE_URI + "/getrentsforcompany";
      self.$http.get(url).then(
        function(success) {
          var paymentstemp = success.data.rents;
          var rentsfinal = [];
          self._.forEach(paymentstemp, function(expense, index) {
            if (self.moment(self.date) > self.moment(expense.rentcreationdate))
              return;
            if (
              self.moment(self.date2) <= self.moment(expense.rentcreationdate)
            )
              return;
            if (expense.rentstatus < 10) {
              paymentstemp[index].rentfromcalc = self.moment(expense.rentfrom);
              paymentstemp[index].renttocalc = self.moment(expense.rentto);

              paymentstemp[index].rentfromf = self
                .moment(expense.rentfrom)
                .format("DD-MM-YYYY")
                .split("T")[0];
              paymentstemp[index].renttof = self
                .moment(expense.rentto)
                .format("DD-MM-YYYY")
                .split("T")[0];

              if (expense.rentstatus === 1) {
                paymentstemp[index].rentstatuslabel = "Solicitado";
                paymentstemp[index].rentstatuscolor = "yellow";
              } else if (expense.rentstatus === 2) {
                paymentstemp[index].rentstatuslabel = "Aprobado";
                paymentstemp[index].rentstatuscolor = "amber";
              } else if (expense.rentstatus === 3) {
                paymentstemp[index].rentstatuslabel = "Firmado";
                paymentstemp[index].rentstatuscolor = "orange";
              } else if (expense.rentstatus === 4) {
                paymentstemp[index].rentstatuslabel = "Firmado";
                paymentstemp[index].rentstatuscolor = "orange";
              } else if (expense.rentstatus === 5) {
                paymentstemp[index].rentstatuslabel = "Pagado";
                paymentstemp[index].rentstatuscolor = "cyan";
              } else if (expense.rentstatus === 6) {
                paymentstemp[index].rentstatuslabel = "Entrega";
                paymentstemp[index].rentstatuscolor = "light-blue";
              } else if (expense.rentstatus === 7) {
                paymentstemp[index].rentstatuslabel = "Recogida";
                paymentstemp[index].rentstatuscolor = "blue";
              } else if (expense.rentstatus === 8) {
                paymentstemp[index].rentstatuslabel = "Liquidación";
                paymentstemp[index].rentstatuscolor = "light-green";
              } else if (expense.rentstatus === 9) {
                paymentstemp[index].rentstatuslabel = "Liquidado";
                paymentstemp[index].rentstatuscolor = "green";
              } if (expense.rentstatus === 10) {
                paymentstemp[index].rentstatuslabel = "Cancelado";
                paymentstemp[index].rentstatuscolor = "red";
              }

              if (expense.transportNeeded === 1) {
                paymentstemp[index].transportNeededlabel = "SI";
              } else {
                paymentstemp[index].transportNeededlabel = "NO";
              }

              if (expense.rentstatus >= 6 && expense.rentstatus < 9) {
                if (expense.rentphase === 1) {
                  paymentstemp[index].rentphaselabel = "Salida";
                }
                if (expense.rentphase === 2) {
                  paymentstemp[index].rentphaselabel = "Entrega";
                }
                if (expense.rentphase === 3) {
                  paymentstemp[index].rentphaselabel = "Recogida";
                }
                if (expense.rentphase === 4) {
                  paymentstemp[index].rentphaselabel = "Devolución";
                }
              } else {
                paymentstemp[index].rentphaselabel = " ";
              }

              if (expense.idpaymentstatus === 1) {
                paymentstemp[index].stateclass = "state1";
                paymentstemp[index].idpaymentstatus = "PENDIENTE";
              }
              if (expense.idpaymentstatus === 2) {
                paymentstemp[index].stateclass = "state2";
                paymentstemp[index].idpaymentstatus = "PAGADO";
              }
              if (expense.idpaymentstatus === 3) {
                paymentstemp[index].stateclass = "state3";
                paymentstemp[index].idpaymentstatus = "RECHAZADO";
              }
              rentsfinal.push(paymentstemp[index]);
            }
          });
          self.rents = rentsfinal;

          rentsfinal.map(self.groupmonth);
          var a = rentsfinal;
          self.rentsinfo.data.datasets[0].data[0] =
            self.bymonth[0] == null ? 0 : self.bymonth[0].length;
          self.rentsinfo.data.datasets[0].data[1] =
            self.bymonth[1] == null ? 0 : self.bymonth[1].length;
          self.rentsinfo.data.datasets[0].data[2] =
            self.bymonth[2] == null ? 0 : self.bymonth[2].length;
          self.rentsinfo.data.datasets[0].data[3] =
            self.bymonth[3] == null ? 0 : self.bymonth[3].length;
          self.rentsinfo.data.datasets[0].data[4] =
            self.bymonth[4] == null ? 0 : self.bymonth[4].length;
          self.rentsinfo.data.datasets[0].data[5] =
            self.bymonth[5] == null ? 0 : self.bymonth[5].length;
          self.rentsinfo.data.datasets[0].data[6] =
            self.bymonth[6] == null ? 0 : self.bymonth[6].length;
          self.rentsinfo.data.datasets[0].data[7] =
            self.bymonth[7] == null ? 0 : self.bymonth[7].length;
          self.rentsinfo.data.datasets[0].data[8] =
            self.bymonth[8] == null ? 0 : self.bymonth[8].length;
          self.rentsinfo.data.datasets[0].data[9] =
            self.bymonth[9] == null ? 0 : self.bymonth[9].length;
          self.rentsinfo.data.datasets[0].data[10] =
            self.bymonth[10] == null ? 0 : self.bymonth[10].length;
          self.rentsinfo.data.datasets[0].data[11] =
            self.bymonth[11] == null ? 0 : self.bymonth[11].length;
          EventBus.$emit("refreshgraph", "some value");
          self.isLoading = false;
        },
        function(error) {
          self.$toast.open({
            duration: 5000,
            message: self.$t("myMachinesErrorGetMachines"),
            type: "is-danger"
          });
          self.isLoading = false;
        }
      );
    },
    groupmonth(value, index, array) {
      var d = new Date(value["rentfrom"]);
      // d = (d.getFullYear()-1970)*12 + d.getMonth();
      d = d.getMonth();
      this.bymonth[d] = this.bymonth[d] || [];
      this.bymonth[d].push(value);
    },
    groupmonth(value, index, array) {
      var d = new Date(value["rentfrom"]);
      // d = (d.getFullYear()-1970)*12 + d.getMonth();
      d = d.getMonth();
      this.bymonth[d] = this.bymonth[d] || [];
      this.bymonth[d].push(value);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    refresh() {
      this.machinesrents = [];
      this.totalrents = 0;
      // this.getmachines();
      this.loadRents();
    },
    formatDate(value) {
      return this.moment(value).format("DD-MM-YYYY");
    }
  }
};
</script>

<style lang="stylus" scoped>
.section-def
  margin-bottom: 50px
.toobar-extension
  margin-left: 5px !important
.breadcrumb-section
  margin-left: -25px !important
.action-btn
  margin-left: 5px !important

.state1{
  background-color :salmon;
  text-color : #ffffff;

}

.state2{
  background-color :green;
  text-color : #ffffff;

}

.state3{
  background-color :red;
  text-color : #ffffff;

}
</style>
